import React from "react";
import {
  Box,
  Typography,
  TextField,
  IconButton,
  Button,
  Divider,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";

const SizeEditorField = ({ sizes, setSizes }) => {
  const handleAdd = () => {
    setSizes((prev) => {
      const nextId =
        prev.length > 0
          ? Math.max(...prev.map((s) => Number(s.sizeId))) + 1
          : 1;

      return [
        ...prev,
        {
          sizeId: nextId,
          name: "",
          price: 0,
          servesUpTo: 1,
        },
      ];
    });
  };

  const handleChange = (index, field, value) => {
    setSizes((prev) =>
      prev.map((s, i) =>
        i === index
          ? {
              ...s,
              [field]:
                field === "price" || field === "servesUpTo"
                  ? Number(value)
                  : value,
            }
          : s
      )
    );
  };

  const handleDelete = (index) => {
    setSizes((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <Box sx={{ mt: 3 }}>
      <Typography fontWeight="bold" sx={{ mb: 1 }}>
        Sizes
      </Typography>

      {sizes.map((size, index) => (
        <Box
          key={size.sizeId}
          sx={{
            display: "flex",
            gap: 2,
            mb: 2,
            alignItems: "center",
            flexWrap: "wrap",
          }}>
          <TextField
            label="Name"
            value={size.name}
            onChange={(e) => handleChange(index, "name", e.target.value)}
            size="small"
          />
          <TextField
            label="Price"
            type="number"
            value={size.price}
            onChange={(e) => handleChange(index, "price", e.target.value)}
            size="small"
          />
          <TextField
            label="Serves Up To"
            type="number"
            value={size.servesUpTo}
            onChange={(e) => handleChange(index, "servesUpTo", e.target.value)}
            size="small"
          />
          <IconButton onClick={() => handleDelete(index)} size="small">
            <DeleteIcon />
          </IconButton>
        </Box>
      ))}

      <Divider sx={{ my: 2 }} />

      <Button
        startIcon={<AddIcon />}
        onClick={handleAdd}
        size="small"
        variant="outlined">
        Add Size
      </Button>
    </Box>
  );
};

export default SizeEditorField;
